import React from "react";

function AccountingQueues() {
  return <div>AccountingQueues</div>;
}

export default AccountingQueues;
